




import Vue from 'vue';

export default Vue.extend({
  name: 'JerseyProgress',
  props: { index: Number },
  mounted() {},
});
